import styled from "styled-components"
import { 
    // COLOR,
    // FONT
 } from 'assets'
 
export const CreatorUploadContainerStyled = styled.div`
/*===============================================
 Container 
===============================================*/
    
/*===============================================
Theme 
===============================================*/
  
`